import { AutomatedMessageProvider } from '@liveHelper/components/AutomatedMessageProvider'
import { LiveHelperComponent } from '@liveHelper/components/LiveHelperComponent'
import { MessagePreviewProvider } from '@liveHelper/components/MessagePreviewProvider'
import { MonitoringProvider } from '@liveHelper/components/MonitoringProvider'
import { OneToOneStoreProvider } from '@liveHelper/components/OneToOneStoreProvider'
import { AppointmentContextProvider } from '@liveHelper/context/AppointmentContext/AppointmentContext'
import { ChatChannelConfigContextProvider } from '@liveHelper/context/ChatChannelConfigContext'
import { CloseWidgetProvider } from '@liveHelper/context/CloseWidgetContext'
import { MessageChannelProvider } from '@liveHelper/context/MessageChannelContext/MessageChannelContext'
import { MonitoringChannelProvider } from '@liveHelper/context/MonitoringChannelContext'
import { SocketProvider } from '@liveHelper/context/SocketContext'
import { VisitorChannelProvider } from '@liveHelper/context/VisitorChannelContext'
import { LiveHelperTranslationProvider } from '@liveHelper/i18n'
import type { LiveHelperParams } from '@liveHelper/params'

/**
 * The live helper widget component
 */
export const LiveHelper: React.FC<{
  initialParams: LiveHelperParams
  widgetAttributes: Record<string, string>
}> = ({ initialParams, widgetAttributes }) => {
  return (
    <ChatChannelConfigContextProvider
      initialParams={initialParams}
      widgetAttributes={widgetAttributes}
    >
      <OneToOneStoreProvider
        initialParams={initialParams}
        widgetAttributes={widgetAttributes}
      >
        <AppointmentContextProvider>
          <LiveHelperTranslationProvider>
            <MonitoringProvider>
              <SocketProvider>
                <VisitorChannelProvider>
                  <MonitoringChannelProvider>
                    <MessagePreviewProvider>
                      <AutomatedMessageProvider>
                        <MessageChannelProvider>
                          <CloseWidgetProvider>
                            <LiveHelperComponent />
                          </CloseWidgetProvider>
                        </MessageChannelProvider>
                      </AutomatedMessageProvider>
                    </MessagePreviewProvider>
                  </MonitoringChannelProvider>
                </VisitorChannelProvider>
              </SocketProvider>
            </MonitoringProvider>
          </LiveHelperTranslationProvider>
        </AppointmentContextProvider>
      </OneToOneStoreProvider>
    </ChatChannelConfigContextProvider>
  )
}
